import Smartphones from 'Integrations/views/KivraOnboardingView/containers/Smartphones'
import Tablets from 'Integrations/views/KivraOnboardingView/containers/Tablets'

import { getCurrentDeviceView } from 'shared/helpers/utils'

const KivraOnboardingView = getCurrentDeviceView(Smartphones, Tablets)

export default KivraOnboardingView
